;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "MpgsHostedCheckoutSdk",
  props: {
    session_id: { type: String, required: true },
    checkout_js_url: { type: String, required: true },
    order_id: { type: String, required: true }
  },
  data: function data() {
    return { loadError: null };
  },
  mounted: function mounted() {
    if (!this.session_id || !this.checkout_js_url) {
      this.loadError = "Missing MPGS checkout initialization data.";
      return;
    }

    this.installCallbacks();

    if (window.Checkout) {
      this.startCheckout();
    } else {
      this.loadScript();
    }
  },
  beforeDestroy: function beforeDestroy() {
    delete window.__mpgs_pesaflow_complete;
    delete window.__mpgs_pesaflow_error;
    delete window.__mpgs_pesaflow_cancel;
    delete window.__mpgs_pesaflow_timeout;
  },

  methods: {
    installCallbacks: function installCallbacks() {
      var self = this;

      window.__mpgs_pesaflow_complete = function (resultIndicator, sessionVersion) {
        self.$emit("payment-complete", {
          sessionId: self.session_id,
          orderId: self.order_id,
          resultIndicator: resultIndicator,
          sessionVersion: sessionVersion
        });
      };

      window.__mpgs_pesaflow_error = function (error) {
        self.$emit("payment-error", error);
      };

      window.__mpgs_pesaflow_cancel = function () {
        self.$emit("payment-cancel", {
          sessionId: self.session_id,
          orderId: self.order_id
        });
      };

      window.__mpgs_pesaflow_timeout = function () {
        self.$emit("payment-timeout", {
          sessionId: self.session_id,
          orderId: self.order_id
        });
      };
    },
    loadScript: function loadScript() {
      var _this = this;

      var script = document.createElement("script");
      script.src = this.checkout_js_url;
      script.async = true;
      script.setAttribute("data-complete", "__mpgs_pesaflow_complete");
      script.setAttribute("data-error", "__mpgs_pesaflow_error");
      script.setAttribute("data-cancel", "__mpgs_pesaflow_cancel");
      script.setAttribute("data-timeout", "__mpgs_pesaflow_timeout");
      script.onload = function () {
        return _this.startCheckout();
      };
      script.onerror = function () {
        _this.loadError = "Failed to load the secure checkout library.";
      };
      document.head.appendChild(script);
    },
    startCheckout: function startCheckout() {
      if (typeof Checkout.showEmbeddedPage !== "function") {
        this.loadError = "Outdated MPGS SDK loaded; update checkout_js_url to /static/checkout/checkout.min.js.";
        return;
      }

      Checkout.configure({ session: { id: this.session_id } });

      Checkout.showEmbeddedPage("#mpgs-embed-target");
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-3"},[_c('div',{staticClass:"min-h-[320px]",attrs:{"id":"mpgs-embed-target"}}),_vm._v(" "),(_vm.loadError)?_c('p',{staticClass:"text-red-500 text-sm"},[_vm._v(_vm._s(_vm.loadError))]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46bab420", __vue__options__)
  } else {
    hotAPI.reload("data-v-46bab420", __vue__options__)
  }
})()}